import type { RatesComponentProps } from './RatesComponent';

export const RatesComponent = {
    MountAsync: async (target: HTMLElement, props: RatesComponentProps) => {
        const { mountReactComponentAsync } = await import('@/utils/mountReactComponentAsync');
        const { RatesComponent } = await import('./RatesComponent');
        return await mountReactComponentAsync(target, RatesComponent, props);
    }
};
